function userDhaq({qof}){
    return(
        <>
        <div className="dhaq_ak">
            <div className="img">
                e
            </div>
            <div className="qoraal_msg">
                <p>Waxaad Xisabisay <span>{qof.Xadiga}</span>{qof.Nooca === "Lacag" ? 
                "$"
                :qof.Nooca === "Dahab"?
                "Giraam"
                :qof.Nooca === "Rikaas" ?
                "Rikaas"
                :qof.Nooca === "Mido" ?
                "Midho"
                : ""
            }</p>
            </div>
            <div className="time">
                <p>12 just now</p>
            </div>
        </div>
        </>
    )
}

export default userDhaq

